import React, { Component } from "react";
import { Text, Box } from "@chakra-ui/layout";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Image, Link } from "@chakra-ui/react";
import "./Slider.css";

//import images
import groupImage1 from "../introduction/images/group11.jpg";
import groupImage2 from "../introduction/images/group10.jpg";
import Slider from "react-slick";

export const settings1 = {
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2000,
  pauseOnHover: true,
};
export const settings2 = {
  ...settings1,
  arrows: true,
};
export default class SimpleSlider extends Component {
  render() {
    return (
      <>
        <Box
          id="news-carousel"
          marginX="auto"
          marginTop="40px"
          width={{ base: "97%", md: "93.7%", xl: "93.7%" }}
          minHeight="70vh"
        >
          {this.props.isMenuOpen ? (
            <Slider {...settings1}>
              <div className="container">
                <div className="inner-text">
                  <Link
                    href="/news/meet-up-with-collaborators-from-cornel-medicine-and-ukm"
                    _focus={{ textDecoration: "none" }}
                    _hover={{ textDecoration: "none" }}
                    isExternal
                  >
                    <Text
                      fontSize={{ base: "18px", md: "25px", lg: "40px" }}
                      borderBottom="1px solid white"
                    >
                      Meet up with collaborators from Cornel Medicine and UKM
                    </Text>
                    <Text fontSize={{ base: "14px", md: "16px", lg: "20px" }}>
                      Click to see details
                    </Text>
                  </Link>
                </div>
                <Image
                  src={groupImage1}
                  alt="image1"
                  width="100%"
                  objectFit="cover"
                  filter="brightness(0.5)"
                  height="670px"
                />
              </div>
              <div className="container">
                <div className="inner-text">
                  <Link
                    href="/news/all-pis-visit-qatar-museum"
                    _focus={{ textDecoration: "none" }}
                    _hover={{ textDecoration: "none" }}
                    isExternal
                  >
                    <Text
                      fontSize={{ base: "18px", md: "25px", lg: "40px" }}
                      borderBottom="1px solid white"
                    >
                      All P.I.s visit Qatar Museum
                    </Text>
                    <Text fontSize={{ base: "14px", md: "16px", lg: "20px" }}>
                      Click to see details
                    </Text>
                  </Link>
                </div>
                <Image
                  src={groupImage2}
                  alt="image2"
                  width="100%"
                  objectFit="cover"
                  filter="brightness(0.5)"
                  height="670px"
                />
              </div>
            </Slider>
          ) : (
            <Slider {...settings2}>
              <div className="container">
                <div className="inner-text">
                  <Link
                    href="/news/meet-up-with-collaborators-from-cornel-medicine-and-ukm"
                    _focus={{ textDecoration: "none" }}
                    _hover={{ textDecoration: "none" }}
                    isExternal
                  >
                    <Text
                      fontSize={{ base: "18px", md: "25px", lg: "40px" }}
                      borderBottom="1px solid white"
                    >
                      Meet up with collaborators from Cornel Medicine and UKM
                    </Text>
                    <Text fontSize={{ base: "14px", md: "16px", lg: "20px" }}>
                      Click to see details
                    </Text>
                  </Link>
                </div>
                <Image
                  src={groupImage1}
                  alt="image1"
                  width="100%"
                  objectFit="cover"
                  filter="brightness(0.5)"
                  height="670px"
                />
              </div>
              <div className="container">
                <div className="inner-text">
                  <Link
                    href="/news/all-pis-visit-qatar-museum"
                    _hover={{ textDecoration: "none" }}
                    _focus={{ textDecoration: "none" }}
                    isExternal
                  >
                    <Text
                      fontSize={{ base: "18px", md: "25px", lg: "40px" }}
                      borderBottom="1px solid white"
                    >
                      All P.I.s visit Qatar Museum
                    </Text>
                    <Text fontSize={{ base: "14px", md: "16px", lg: "20px" }}>
                      Click to see details
                    </Text>
                  </Link>
                </div>
                <Image
                  src={groupImage2}
                  alt="image2"
                  width="100%"
                  objectFit="cover"
                  filter="brightness(0.5)"
                  height="670px"
                />
              </div>
            </Slider>
          )}
        </Box>
      </>
    );
  }
}
